export default "__VITE_ASSET__De82W5vd__"